import { render } from "./home-footer.vue?vue&type=template&id=f488ed48&scoped=true"
const script = {}

import "./home-footer.vue?vue&type=style&index=0&id=f488ed48&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f488ed48"]])

export default __exports__